<template>

	<div v-if="classLevel === 'Fundamental_1' || classLevel === 'Fundamental_2' || classLevel === 'EnsinoMedio'">

		<div class="portlet box red text-center">
			<div class="portlet-title">
				<div class="caption">
					<i class="fa fa-bolt"></i>
					Presença em aula
				</div>
			</div>

			<div class="portlet-body">
				<div class="table-responsible">
					<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th scope="col" class="text-center"> Horário </th>
								<th scope="col" class="text-center"> Disciplina </th>
								<th scope="col" class="text-center"> Presença </th>
							</tr>
						</thead>

						<tbody>
							<tr class="form-group">
								<td> 07:30 </td>
								<td> Matemática </td>
								<td class="mt-radio-inline">
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" checked>Presente
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente">Atrasado
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" >Ausente
										<span> </span>
									</label>
								</td>
							</tr>
							<tr class="form-group">
								<td> 07:30 </td>
								<td> Matemática </td>
								<td class="mt-radio-inline">
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" checked>Presente
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente">Atrasado
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" >Ausente
										<span> </span>
									</label>
								</td>
							</tr>
							<tr class="form-group">
								<td> 07:30 </td>
								<td> Matemática </td>
								<td class="mt-radio-inline">
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" checked>Presente
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente">Atrasado
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" >Ausente
										<span> </span>
									</label>
								</td>
							</tr>
							<tr class="form-group">
								<td> 07:30 </td>
								<td> Matemática </td>
								<td class="mt-radio-inline">
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" checked>Presente
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente">Atrasado
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" >Ausente
										<span> </span>
									</label>
								</td>
							</tr>
							<tr class="form-group">
								<td> 07:30 </td>
								<td> Matemática </td>
								<td class="mt-radio-inline">
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" checked>Presente
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente">Atrasado
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" >Ausente
										<span> </span>
									</label>
								</td>
							</tr>
							<tr class="form-group">
								<td> 07:30 </td>
								<td> Matemática </td>
								<td class="mt-radio-inline">
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" checked>Presente
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente">Atrasado
										<span> </span>
									</label>
									<label class="mt-radio mt-radio-outline">
										<input type="radio" name="presence" value="Presente" >Ausente
										<span> </span>
									</label>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	import StudentPresenceThemes from './';
	export default StudentPresenceThemes;

</script>



// WEBPACK FOOTER //
// main.vue?0588c496